import { enableProdMode, NgZone } from "@angular/core";
import "zone.js";
import "reflect-metadata";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { UIRouter, UrlService } from "@uirouter/core";
import { setAngularJSGlobal } from "@angular/upgrade/static";
import angular from "angular";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import app from "@gtmhub/gtmhub";

if (environment.production) {
  enableProdMode();
}

setAngularJSGlobal(angular);

app.config(["$urlServiceProvider", ($urlService: UrlService): void => $urlService.deferIntercept()]);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((platformRef) => {
    const urlService = platformRef.injector.get(UIRouter).urlService;

    // Instruct UIRouter to listen to URL changes
    const ngZone: NgZone = platformRef.injector.get(NgZone);
    ngZone.run(function startUIRouter() {
      urlService.listen();
      urlService.sync();
    });
  })
  .catch((err) => console.error(err));
